import { createFlowId, createStepId } from '@hunting-nature/shared-core/step-progress';
import type { StepProgressFlowConfig } from '@hunting-nature/shared-core/step-progress';

/**
 * Step ID constants for the add camera flow.
 * Order determines step position
 */
export const AddCameraFlowStepId = {
  ADD_CAMERA: 'add-camera',
  TEST_CONNECTION: 'test-connection',
  GPS_SETUP: 'gps-setup',
  SETUP_COMPLETE: 'setup-complete',
} as const;

export type AddCameraFlowStepId = (typeof AddCameraFlowStepId)[keyof typeof AddCameraFlowStepId];

const stepIds = Object.values(AddCameraFlowStepId);

export const ADD_CAMERA_FLOW_CONFIG: StepProgressFlowConfig = {
  flowId: createFlowId('add-camera-flow'),
  baseRoute: '/add-camera-flow',
  showProgressIndicator: true,
  steps: stepIds.map((id, index) => ({
    id: createStepId(id),
    position: index + 1,
    showInProgress: true,
  })),
} as const;

export const ADD_CAMERA_TOTAL_STEPS = ADD_CAMERA_FLOW_CONFIG.steps.length;

export const ADD_CAMERA_FIRST_STEP: AddCameraFlowStepId = AddCameraFlowStepId.ADD_CAMERA;

export const ADD_CAMERA_LAST_STEP: AddCameraFlowStepId = AddCameraFlowStepId.SETUP_COMPLETE;
